module.exports = __webpack_public_path__ + "static/Lamentum6-1655f204578ec42379dbc6d18be2bc56.png";